import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {States} from "../../shared/config/constant.module";
import template from './productionShiftReport.tpl.html';
import {StateParams} from "../../common";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import { Plant } from '../../models/navigation';
import { apsViewModels } from '../../shared/dto/APS.ViewModels';
import { apsEnums } from "../../shared/dto/aps.enums";
import EnvironmentName, { Environment } from "../../shared/config/environment";

let requires = [LoaderServiceName, ReportServiceName, AuthDataServiceName, NavigationServiceName, EnvironmentName];
  
interface ProductionShiftReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;
  report: apsViewModels.ProductionShiftReportData;
  formattedReportDate: string;
  appPath: string;
}

export interface ProductionShiftReportParams extends StateParams {
  reportPlantId: string;
  reportDate: string;
}

class ProductionShiftReportCtrl implements ProductionShiftReportController {
  plants: Plant[];
  selectedPlant: Plant;
  reportDate: Date;
  form: angular.IFormController;
  report: apsViewModels.ProductionShiftReportData;
  formattedReportDate: string;
  maxMachineSections: number;
  appPath: string;
  showExcel: boolean;
  isWeekend: boolean;
  isPreRelease: boolean;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  authDataService: AuthDataService;
  environment: Environment
  $q: angular.IQService;

  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;
  
  private $stateParams: ProductionShiftReportParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: ProductionShiftReportParams,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    environment: Environment,
    $q: angular.IQService) {

    var vm = this;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.authDataService = authDataService;
    this.environment = environment;
    this.$q = $q;
    this.showExcel = true;

    this.reportDate = moment().add(-1, 'days').toDate();

    var promise = navigationService.getNavigation().then((navModel) => {
       this.plants = navModel.plants();
       this.selectedPlant = navModel.selectedPlant;

       this.loadState($stateParams);
 
    });

    this.appPath = this.environment.API_PATH;

    loaderService.loadingPromise(promise.then(() => {
      if($stateParams.userId == 'd7660000-ff45-0003-cea2-08d59f072b0f')
      {
        this.showExcel = false;
        this.generateReport(false);
      }
    }));
   
  }
  
  loadState(params: ProductionShiftReportParams): void {
    if (params.reportPlantId && params.reportPlantId !== params.plantId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        this.selectedPlant = plant;
      }
    }

    if (params.reportDate) {
      var reportDate = moment(params.reportDate);
      if (reportDate.isValid()) {
        this.reportDate = reportDate.toDate();
      }
    }
  }

  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
    var params: ProductionShiftReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  getMaxMachineSections(){
    return new Array(this.maxMachineSections);
  }

  getMachineName(shop: apsViewModels.ShiftReportShopItem, index: number): string{
    let machine = shop.shifts[1].lineItem.machineLosses[index];    
    return machine == null ? '' : machine.machineName;
  }

  getMachineLossForShift(shift: apsViewModels.ShiftReportShiftItem, index: number): string {
    let machine = shift.lineItem.machineLosses[index];
    return machine == null ? '' : machine.loss.toFixed(1);    
  }

  getMachineLossForShop(shop: apsViewModels.ShiftReportShopItem, index: number): string {
    if (shop.shopTotals == null || shop.shopTotals.machineLosses == null){
      return null;
    }    

    let machine = shop.shopTotals.machineLosses[index];
    return machine == null ? '' : machine.loss.toFixed(1);
  }

  getMachineLossForLine(shift: apsViewModels.ShiftReportShiftItem, machineIndex: number, line: string): string {
    let machine = shift.lineItem.machineLosses[machineIndex];   
    let lineDetail = machine == null ? null : _.find(machine.lineDetail, function(detail) { return detail.line == line; });

    return lineDetail == null ? '' : lineDetail.lossPercentage.toFixed(1);
  }

  getDistinctLinesForShop(losses: apsViewModels.ShiftReportMachineLosses[]){
    return _.uniq(_.flatten(losses.map(function(obj) {
      return obj.lineDetail.map(function(obj2) {
        return obj2.line;
      })
    })));  
  }

  updatePlant() {
    this.report = null;
  }

  generateReport(regenerate: boolean) {
    if (this.form.$invalid) {
      return;
    }
  
    this.saveState();
    this.loaderService.loadingPromise(this.runReport());
    this.formattedReportDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");    
    if(this.formattedReportDate.indexOf("Friday") == -1 && this.formattedReportDate.indexOf("Saturday") == -1)
    {
      this.isWeekend = false;
    }
    else
    {
      this.isWeekend = true;
    }
    
    this.isPreRelease = false;

    if(this.selectedPlant.id === 'bbdf0000-3a00-000d-d6c3-08d2e5fa8dd2')
    {
      this.isPreRelease = true;
    }

  }

  exportToExcel() {
    this.loaderService.loadingPromise(this.reportService.exportToExcel(apsEnums.ExcelExports.ProductionReport, this.selectedPlant.id, this.reportDate));
  };

  private setMaxMachines(){
    let maxMachines = 0;
    _.forEach(this.report.shops, function(shop) {     
      _.forEach(shop.shifts, function(shift){
        let machineCount = shift.lineItem.machineLosses.length;        
        if (machineCount > maxMachines) {
          maxMachines = machineCount;
        }      
      });         
    });

    this.maxMachineSections = maxMachines;   
  }

  private runReport(): angular.IPromise<any> {  
    let promise = this.reportService.getProductionShiftReport(this.selectedPlant.id, this.reportDate);

    promise.then((report: apsViewModels.ProductionShiftReportData) => {
      this.report = report;    
      this.setMaxMachines();  
    });   
        
    return promise;
  }
}

export default angular.module('aps.controller.productionShiftReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.PRODUCTION_SHIFT_REPORT,
      url: '/productionShiftReportV1',
      params: {
        reportDate: {dynamic: true},
        reportPlantId: {dynamic: true}
      },
      controller: 'ProductionShiftReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Production Shift Report'
      }
    });
  })
  .controller('ProductionShiftReportCtrl', ProductionShiftReportCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/productionShiftReport.controller.ts